import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-387fb2a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card mb-25 border-0 rounded-0 bg-white",
  id: "chartCard"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-20 text-uppercase fw-bold text-dark-emphasis" }, " Suggested System - Pie Chart ", -1))
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle card-dot-btn lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1))
const _hoisted_7 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_10 = { class: "d-flex justify-content-between mb-3" }
const _hoisted_11 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Basic outlined example"
}
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "suggestedSystemLegend",
  class: "legend me-3"
}, null, -1))
const _hoisted_14 = {
  id: "suggestedSystemChart",
  class: "chart"
}
const _hoisted_15 = { id: "chartContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportChart('jpg')))
              }, [
                _hoisted_8,
                _createTextVNode(" Export as JPG ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportChart('png')))
              }, [
                _hoisted_9,
                _createTextVNode(" Export as PNG ")
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.activeMetric === 'SKUQuantity' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setMetric('SKUQuantity')))
          }, " SKU Quantity ", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.activeMetric === 'VolumeInStock' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMetric('VolumeInStock')))
          }, " Volume In Stock ", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.activeMetric === 'VolumePerDay' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setMetric('VolumePerDay')))
          }, " Volume Per Day ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_apexchart, {
              ref: "apexChart",
              type: "pie",
              height: "300",
              options: _ctx.chartOptions,
              series: _ctx.filteredSeries,
              id: 'chartContainer'
            }, null, 8, ["options", "series"])
          ])
        ])
      ])
    ])
  ]))
}